import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useTippy } from 'vue-tippy';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkContextMenu',
  props: {
  options: {
    type: Object,
    default: () => ({}),
  },
  active: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props



const contextMenuReference = ref();
const contextMenuContent = ref();

const id = (Math.random() + 1).toString(36).substring(7);
const identifier = `context-${ id }`;

const { setProps, show, hide } = useTippy(() => document.body, {
  placement: 'right-start',
  trigger: 'manual',
  interactive: true,
  arrow: false,
  offset: [0, 0],
  ...props.options,
  content: () => contextMenuContent.value,
});

const handleReferenceClick = (event: MouseEvent) => {
  setProps({
    delay: 0,
    duration: 0,
    getReferenceClientRect: () => ({
      width: 2,
      height: 2,
      top: event.clientY,
      bottom: event.clientY,
      left: event.clientX,
      right: event.clientX,
    }),
  });

  show();
};

const handleClicksEvents = (e: MouseEvent) => {
  if (!props.active) {
    return;
  }

  if (!(e.target as HTMLElement).closest(`.${ identifier }`) && !(e.target as HTMLElement).closest('[data-tippy-root]')) {
    hide();
  }

  if ((e.target as HTMLElement).closest(`.${ identifier }`)) {
    e.preventDefault();
    handleReferenceClick(e);
  }
};

onMounted(() => {
  document.addEventListener('contextmenu', handleClicksEvents);
  document.addEventListener('click', handleClicksEvents);
});

onBeforeUnmount(() => {
  document.removeEventListener('contextmenu', handleClicksEvents);
  document.removeEventListener('click', handleClicksEvents);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["inline", [identifier]]),
      ref_key: "contextMenuReference",
      ref: contextMenuReference
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _createElementVNode("ul", {
      class: "nk-context-menu nk-context-menu-wrapper",
      ref_key: "contextMenuContent",
      ref: contextMenuContent
    }, [
      _renderSlot(_ctx.$slots, "content", { hide: _unref(hide) })
    ], 512)
  ], 64))
}
}

})